import { FunctionComponent } from "react";
import DropdownFilter from "../../../../components/DropdownFilter";
import { Selection } from "../../../search/@types";
import { addAllOption } from "./ExtractedFilesFileFormatFilter";
import { MENU_STYLE } from "./const";
import { getActiveItemTitle } from "./utils";

type ExtractedFilesThreatNameFilterProps = {
  index: number;
  disabled?: boolean;
  active: string;
  onChange: (selectedValue: Selection) => void;
  menuItems: Selection[];
};
export const ExtractedFilesThreatNameFilter: FunctionComponent<
  ExtractedFilesThreatNameFilterProps
> = ({ index, disabled, active, onChange, menuItems }) => {
  const menuItemsWithAllOption = addAllOption(menuItems, "All Threats");
  const title = getActiveItemTitle(menuItemsWithAllOption, active);

  return (
    <DropdownFilter
      eventKey={index}
      title={<span>{title}</span>}
      field="threatName"
      activeFilter={active}
      menuItems={addAllOption(menuItems)}
      onFilterChange={onChange}
      disabled={disabled}
      styleVariant="primary"
      styles={{ menu: MENU_STYLE }}
    />
  );
};
